import {
  type ConsentSubmission,
  ConsentSubmissionStatusEnum,
} from "src/graphql-next/generated/types";

export function isUnknownToConsentPlatform(
  submission: Pick<ConsentSubmission, "status"> | null,
): boolean {
  return (
    submission === null ||
    submission.status === ConsentSubmissionStatusEnum.Failed
  );
}
